import React from 'react';
import { Calendar, Tag, Popover } from 'antd';
import * as dayjs from 'dayjs';
import type { CellRenderInfo } from 'rc-picker/lib/interface';
import { CalendarItem } from './shared';
import CalendarEventsPopover from './CalendarEventsPopover';
import { useCalendarEvents } from './useCalendarEvents';

type Props = {};

const MonthCellRender = ({ current }: { current: dayjs.Dayjs }) => {
  const [month, year] = [current.month(), current.year()];
  const currentMonthItems: CalendarItem[] = useCalendarEvents({
    year,
    month,
  });
  return (
    <ul className="events">
      {currentMonthItems.map(item => (
        <li key={item.name}>{item.name}</li>
      ))}
    </ul>
  );
};

const DateCellRender = ({ current }: { current: dayjs.Dayjs }) => {
  const [day, month, year] = [current.date(), current.month(), current.year()];
  const currentMonthItems: CalendarItem[] = useCalendarEvents({
    year,
    month,
    day,
  });
  console.log(month, currentMonthItems);
  return (
    <Popover content={<CalendarEventsPopover day={day} month={month + 1} />}>
      <div className="events" style={{ overflow: 'hidden', height: '100%' }}>
        {currentMonthItems.map(item => (
          <Tag color="blue" style={{ marginBottom: 10 }} key={item.name}>
            {item.name}
          </Tag>
        ))}
      </div>
    </Popover>
  );
};

const CalendarTab = (props: Props) => {
  const cellRender = (current: dayjs.Dayjs, info: CellRenderInfo<dayjs.Dayjs>) => {
    if (info.type === 'date') return <DateCellRender current={current} />;
    if (info.type === 'month') return <MonthCellRender current={current} />;
    return info.originNode;
  };

  // const handleCreateNewEvent = async () => {
  //   dispatch(
  //     openModal({
  //       modalName: 'calendarItemDetailModal',
  //     })
  //   );
  // };

  return (
    <Calendar defaultValue={dayjs.default()} cellRender={cellRender} />
    /* <Col span={8}>
        <Card title="Settings">
          <Button style={{ width: '100%' }} onClick={handleCreateNewEvent}>
            <PlusOutlined /> Create new event
          </Button>
        </Card>
      </Col> */
  );
};
export default CalendarTab;
